import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import { SvgXml } from 'react-native-svg';
import DyteText from './DyteText';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  variant,
  size,
  iconPack = defaultIconPack,
  t,
}: {
  variant?: 'button' | 'horizontal';
  size?: 'lg' | 'md' | 'sm' | 'xl';
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  let buttonSize = 25;
  let isButton = true;
  switch (size) {
    case 'sm':
      buttonSize = 50;
      break;
    case 'lg':
      buttonSize = 100;
      break;
    case 'xl':
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      buttonSize = 150;
      break;
  }
  switch (variant) {
    case 'horizontal':
      isButton = false;
      break;
  }
  const styles = StyleSheet.create({
    button: {
      height: 56,
      width: 56,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: isButton ? (size === 'sm' ? 'row' : 'column') : 'row',
    },
    text: {
      fontSize: 12,
    },
  });
  return (
    <View>
      {isButton ? (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({ ...storeStates, activeLeaveConfirmation: true });
          }}
          // eslint-disable-next-line react-native/no-inline-styles
          style={{
            ...styles.button,
            backgroundColor: colors.danger,
            borderRadius: 4,
          }}
        >
          <SvgXml
            xml={iconPack.call_end.replace('currentColor', colors.text)}
            width={25}
            height={25}
          />
        </TouchableHighlight>
      ) : (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({ ...storeStates, activeLeaveConfirmation: true });
          }}
          style={styles.button}
        >
          <View>
            <SvgXml
              xml={iconPack.call_end.replace('currentColor', colors.danger)}
              width={25}
              height={25}
            />
            <DyteText style={styles.text}>{t('leave')}</DyteText>
          </View>
        </TouchableHighlight>
      )}
    </View>
  );
}
